import React, { useEffect, createElement } from 'react';
import { useLocation } from 'react-router-dom';
const PIXEL_ID = '1413548533871491';
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}
export function MetaPixel() {
  const location = useLocation();
  // Inject the Meta Pixel script once on mount
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (window.fbq) return;
    try {
      // Lightweight, defensive injection equivalent to the standard fbq snippet.
      const queue: unknown[][] = [];
      const fbq: ((...args: unknown[]) => void) & {
        queue?: unknown[][];
        loaded?: boolean;
        version?: string;
        push?: unknown;
        callMethod?: (...args: unknown[]) => void;
      } = function (...args: unknown[]) {
        if (typeof fbq.callMethod === 'function') {
          fbq.callMethod.apply(fbq, args);
        } else {
          queue.push(args);
        }
      } as unknown as typeof fbq;
      fbq.queue = queue;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.push = fbq;
      window.fbq = fbq;
      // @ts-expect-error _fbq is part of Meta's snippet
      window._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const target = document.head || document.body;
      if (target) target.appendChild(script);
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch (err) {
      // Never let analytics break the page
      // eslint-disable-next-line no-console
      console.warn('Meta Pixel init failed:', err);
    }
  }, []);
  // Track PageView on every route change (SPA navigation)
  useEffect(() => {
    try {
      window.fbq?.('track', 'PageView');
    } catch {
      // ignore
    }
  }, [location.pathname]);
  // <noscript> fallback pixel for users with JS disabled
  return <noscript data-id="element-120">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-121" />
    </noscript>;
}